import { FixedBottomBarContainer } from 'noddi-ui-web';
import { PropsWithChildren } from 'react';
import { useShowsSelectionBottomBar } from './useShowsSelectionBottomBar';

type Props = {
  hasSelection: boolean;
};

/** Action bar for picker steps — see `useShowsSelectionBottomBar` for when it shows. */
export const SelectionBottomBar = ({ hasSelection, children }: PropsWithChildren<Props>) => {
  const showsBottomBar = useShowsSelectionBottomBar(hasSelection);

  if (!showsBottomBar) {
    return null;
  }

  return <FixedBottomBarContainer>{children}</FixedBottomBarContainer>;
};
